var exports = {
  "k": "xfd349460--9df8c0--container",
};

module.exports = exports;
